import styled from 'styled-components'

export const Text = styled.span`
    font-family: ${props => props.type && 'NotoSansCJKkr-' + props.type};
    font-size: ${props => props.size && props.size};
    color: ${props => props.color && props.color};
`